module.exports = __webpack_public_path__ + "img/conact.cbefe0d3.png";